import ProfilePage from 'components/template/profile';

export default function PublicProfile() {
  return <ProfilePage />;
}
